import { FormattedMessage } from 'react-intl';

function NotificationSettingsWarningPage() {

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "65vh" }}>
            <h2 style={{ fontSize: "24px", fontWeight: 900, margin: 0 }}>
                <FormattedMessage id="notifications_can_be_edit_on_mobile_app" />
            </h2>
        </div>
    )
}

export default NotificationSettingsWarningPage;